(function () {
  'use strict';

  var CART_URL_RE = /\/cart\/(add|change|update)(\.js|\.json)?(\?|$)/;
  var pendingAction = null;
  var pendingTimer = null;

  function setPending(action) {
    pendingAction = action;
    clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () { pendingAction = null; }, 5000);
  }

  function showToast(msg, isError) {
    var toast = document.getElementById('custom-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'custom-toast';
      toast.setAttribute('role', 'status');
      toast.style.cssText = 'position:fixed;top:20px;right:20px;color:#fff;padding:12px 18px;border-radius:6px;font-size:14px;font-weight:600;z-index:99999999;display:none;box-shadow:0 5px 15px rgba(0,0,0,.2);';
      document.body.appendChild(toast);
    }
    toast.style.background = isError ? '#b42318' : '#002451';
    toast.textContent = msg;
    toast.style.display = 'block';
    clearTimeout(window.toastTimer);
    window.toastTimer = setTimeout(function () { toast.style.display = 'none'; }, 2500);
  }
  window.cartToast = showToast;

  function syncMinusButtons() {
    document.querySelectorAll('.quantity-input').forEach(function (wrap) {
      var input = wrap.querySelector('[data-quantity-input]');
      var minus = wrap.querySelector('[data-subtract-quantity]');
      if (!input || !minus) return;
      var atMin = (parseInt(input.value, 10) || 1) <= 1;
      minus.classList.toggle('is-at-min', atMin);
      minus.setAttribute('aria-disabled', atMin ? 'true' : 'false');
    });
  }

  // Capture phase: runs before the theme's own handlers
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var minus = e.target.closest('[data-subtract-quantity]');
    if (minus) {
      var wrap = minus.closest('.quantity-input');
      var input = wrap && wrap.querySelector('[data-quantity-input]');
      var qty = input ? parseInt(input.value, 10) : 1;
      if (isNaN(qty) || qty <= 1) {      // minus must never remove the product
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      setPending('decrease');
      return;
    }
    if (e.target.closest('[data-add-quantity]')) { setPending('increase'); return; }
    if (e.target.closest('[data-remove-item]')) { setPending('remove'); }
  }, true);

  document.addEventListener('focusin', function (e) {
    if (e.target.matches && e.target.matches('[data-quantity-input]')) {
      e.target.dataset.prevQty = e.target.value;
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-quantity-input]')) return;
    var val = parseInt(input.value, 10);
    var prev = parseInt(input.dataset.prevQty, 10);
    if (isNaN(val) || val < 1) {         // typing 0 must not remove the product
      e.stopImmediatePropagation();
      input.value = (isNaN(prev) || prev < 1) ? 1 : prev;
      return;
    }
    if (!isNaN(prev) && val !== prev) setPending(val > prev ? 'increase' : 'decrease');
    input.dataset.prevQty = String(val);
  }, true);

  // Show toasts only after Shopify answers
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input) {
      var promise = origFetch.apply(this, arguments);
      var url = typeof input === 'string' ? input : ((input && input.url) || '');
      var match = url.match(CART_URL_RE);
      if (!match) return promise;
      var endpoint = match[1];

      promise.then(function (res) {
        return res.clone().json().catch(function () { return {}; }).then(function (data) {
          var failed = !res.ok || (data && data.status && data.status >= 400);
          if (failed) {
            showToast((data && (data.description || data.message)) || 'That quantity is not available.', true);
       } else if (endpoint === 'add') {
  showToast('Product added to cart successfully!');
} else if (pendingAction) {
            var msgs = { increase: 'Quantity increased!', decrease: 'Quantity decreased!', remove: 'Product removed from cart!' };
            showToast(msgs[pendingAction]);
          }
          pendingAction = null;
          setTimeout(syncMinusButtons, 500);
          setTimeout(syncMinusButtons, 1200);
        });
      }).catch(function () {});

      return promise;
    };
  }

  document.addEventListener('DOMContentLoaded', function () {
    syncMinusButtons();
    var saved = null;
    try { saved = sessionStorage.getItem('cartToast'); sessionStorage.removeItem('cartToast'); } catch (err) {}
    if (saved) showToast(saved);
  });
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-quantity-input]')) syncMinusButtons();
  });
})();

// js for recently searched products 

/* =========================================
   RECENTLY SEARCHED KEYWORDS
========================================= */

document.addEventListener('DOMContentLoaded', function () {

  const STORAGE_KEY = 'shopify_recent_searches';
  const MAX_SEARCHES = 5;

  const quickSearch = document.querySelector('[data-quick-search]');
  const searchForm = document.querySelector('[data-quick-search-form]');
  const searchInput = document.querySelector('[data-quick-search-form] [data-input]');
  const recentWrapper = document.querySelector('[data-recent-searches]');
  const recentList = document.querySelector('[data-recent-search-list]');
  const clearButton = document.querySelector('[data-clear-recent-searches]');

  if (
    !quickSearch ||
    !searchForm ||
    !searchInput ||
    !recentWrapper ||
    !recentList
  ) {
    return;
  }


  /* -----------------------------------------
     GET SAVED SEARCHES
  ----------------------------------------- */

  function getRecentSearches() {

    try {

      const saved = localStorage.getItem(STORAGE_KEY);

      if (!saved) {
        return [];
      }

      const searches = JSON.parse(saved);

      return Array.isArray(searches) ? searches : [];

    } catch (error) {

      console.warn('Recent search error:', error);

      return [];

    }
  }


  /* -----------------------------------------
     SAVE SEARCH
  ----------------------------------------- */

  function saveRecentSearch(term) {

    term = term.trim();

    if (!term) {
      return;
    }

    let searches = getRecentSearches();

    /*
      Remove duplicate
    */
    searches = searches.filter(function (item) {
      return item.toLowerCase() !== term.toLowerCase();
    });


    /*
      Add newest search to beginning
    */
    searches.unshift(term);


    /*
      Keep latest 5
    */
    searches = searches.slice(0, MAX_SEARCHES);


    try {

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(searches)
      );

    } catch (error) {

      console.warn('Unable to save recent search:', error);

    }

    renderRecentSearches();

  }


  /* -----------------------------------------
     RENDER RECENT SEARCHES
  ----------------------------------------- */

  function renderRecentSearches() {

    const searches = getRecentSearches();

    recentList.innerHTML = '';


    /*
      Nothing saved
    */
    if (!searches.length) {

      recentWrapper.hidden = true;

      return;

    }


    recentWrapper.hidden = false;


    searches.forEach(function (term) {

      const button = document.createElement('button');

      button.type = 'button';

      button.className = 'quick-search__recent-item';

      button.setAttribute(
        'data-recent-search',
        term
      );


      button.innerHTML = `
        <span class="quick-search__recent-icon">
          <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
            focusable="false"
          >
            <circle
              cx="10.5"
              cy="10.5"
              r="6.5"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
            ></circle>

            <path
              d="M16 16L21 21"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
            ></path>
          </svg>
        </span>

        <span class="quick-search__recent-text"></span>
      `;


      button.querySelector(
        '.quick-search__recent-text'
      ).textContent = term;


      recentList.appendChild(button);

    });

  }


  /* -----------------------------------------
     SHOW RECENT SEARCHES
  ----------------------------------------- */

  function showRecentSearches() {

    if (!getRecentSearches().length) {
      recentWrapper.hidden = true;
      return;
    }

    recentWrapper.hidden = false;

  }


  /* -----------------------------------------
     HIDE RECENT SEARCHES
  ----------------------------------------- */

  function hideRecentSearches() {

    recentWrapper.hidden = true;

  }


  /* -----------------------------------------
     FORM SUBMIT
  ----------------------------------------- */

  searchForm.addEventListener('submit', function () {

    const term = searchInput.value.trim();

    if (!term) {
      return;
    }

    saveRecentSearch(term);

  });


  /* -----------------------------------------
     SEARCH INPUT
  ----------------------------------------- */

  searchInput.addEventListener('input', function () {

    const value = searchInput.value.trim();

    if (value) {

      /*
        Customer is typing
      */
      hideRecentSearches();

    } else {

      /*
        Search field is empty
      */
      showRecentSearches();

    }

  });


  /* -----------------------------------------
     RECENT SEARCH CLICK
  ----------------------------------------- */

  recentList.addEventListener('click', function (event) {

    const button = event.target.closest(
      '[data-recent-search]'
    );

    if (!button) {
      return;
    }

    const term = button.getAttribute(
      'data-recent-search'
    );

    if (!term) {
      return;
    }


    /*
      Put keyword into search field
    */
    searchInput.value = term;


    /*
      Save it as newest search
    */
    saveRecentSearch(term);


    /*
      Trigger the same input event
      used by Shopify predictive search
    */
    searchInput.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );


    /*
      Submit search
    */
    searchForm.requestSubmit();

  });


  /* -----------------------------------------
     CLEAR ALL
  ----------------------------------------- */

  if (clearButton) {

    clearButton.addEventListener(
      'click',
      function () {

        localStorage.removeItem(STORAGE_KEY);

        recentList.innerHTML = '';

        recentWrapper.hidden = true;

      }
    );

  }


  /* -----------------------------------------
     SEARCH DRAWER OPEN / CLOSE
  ----------------------------------------- */

  let previousState =
    quickSearch.getAttribute('aria-hidden');


  const observer = new MutationObserver(function () {

    const currentState =
      quickSearch.getAttribute('aria-hidden');


    /*
      Drawer has just opened
    */
    if (
      previousState === 'true' &&
      currentState === 'false'
    ) {

      /*
        Show recent searches immediately
        when drawer opens.
      */
      showRecentSearches();

    }


    previousState = currentState;

  });


  observer.observe(quickSearch, {
    attributes: true,
    attributeFilter: ['aria-hidden']
  });


  /* -----------------------------------------
     INITIAL LOAD
  ----------------------------------------- */

  renderRecentSearches();

});

// For blog pages issues previously added in theme.liquid file
(function () {
  'use strict';

  const isTaggedPage = window.location.pathname.includes('/blogs/news/tagged/');
  if (!isTaggedPage) return;

  let updateTimer = null;
  let lastUrl = window.location.href;

  function fixTaggedBlogUI() {
    const wrapper = document.querySelector('.blog-tags-wrapper');

    if (wrapper) {
      wrapper.style.display = 'block';
      wrapper.style.visibility = 'visible';
      wrapper.style.opacity = '1';
    }

    if (typeof window.handleTaggedPageUI === 'function') {
      window.handleTaggedPageUI();
    }
  }

  function scheduleFix(delay) {
    clearTimeout(updateTimer);

    updateTimer = setTimeout(function () {
      updateTimer = null;
      fixTaggedBlogUI();
    }, delay);
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleFix(300);
    }, { once: true });
  } else {
    scheduleFix(300);
  }

  // Back / forward navigation
  window.addEventListener('pageshow', function () {
    scheduleFix(300);
  });

  // Watch dynamic DOM changes
  const observer = new MutationObserver(function (mutations) {
    for (const mutation of mutations) {
      if (mutation.addedNodes && mutation.addedNodes.length) {
        scheduleFix(150);
        break;
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Detect URL changes
  function checkUrlChange() {
    if (window.location.href !== lastUrl) {
      lastUrl = window.location.href;

      if (window.location.pathname.includes('/blogs/news/tagged/')) {
        scheduleFix(300);
      }
    }
  }

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function () {
    const result = originalPushState.apply(this, arguments);
    checkUrlChange();
    return result;
  };

  history.replaceState = function () {
    const result = originalReplaceState.apply(this, arguments);
    checkUrlChange();
    return result;
  };

  window.addEventListener('popstate', checkUrlChange);

})();


//Refresh only when the cart page really needs redrawing
var fadRefreshTimer = null;
function FAD_refresh() {
  clearTimeout(fadRefreshTimer);
  fadRefreshTimer = setTimeout(function () {
    // Product, collection and every other page: never reload
    if (!/\/cart\/?$/.test(window.location.pathname)) return;

    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var rows = document.querySelectorAll('.cart__form-item[data-key]');
        var shownKeys = Array.prototype.map.call(rows, function (r) { return r.getAttribute('data-key'); }).sort().join('|');
        var cartKeys = cart.items.map(function (i) { return i.key; }).sort().join('|');
        // Reload only if a gift or split line was added or removed
        if (shownKeys !== cartKeys) window.location.reload();
      })
      .catch(function () {});
  }, 300);
}


(function () {
  if (!document.querySelector('[data-section-type="cart"]')) return;
  var busy = false;

  function changeLine(key, qty, msg) {
    if (busy || !key) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (res) {
      if (!res.ok) { busy = false; return; }
      try { sessionStorage.setItem('cartToast', msg); } catch (err) {}
      window.location.reload();
    }).catch(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-add-quantity],[data-subtract-quantity],[data-remove-item]');
    var row = btn && btn.closest('.cart__form-item');
    if (!row) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var input = row.querySelector('[data-quantity-input]');
    var qty = parseInt(input.value, 10) || 1;
    var key = row.getAttribute('data-key');
    if (btn.matches('[data-remove-item]')) return changeLine(key, 0, 'Product removed from cart!');
    if (btn.matches('[data-add-quantity]')) return changeLine(key, qty + 1, 'Quantity increased!');
    if (qty > 1) changeLine(key, qty - 1, 'Quantity decreased!');
  }, true);

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-quantity-input]');
    var row = input && input.closest('.cart__form-item');
    if (!row) return;
    e.stopImmediatePropagation();
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 1) { input.value = input.defaultValue || 1; return; }
    changeLine(row.getAttribute('data-key'), qty, 'Cart updated!');
  }, true);
})();